module.exports = __webpack_public_path__ + "images/234235fc463d41b8275a6bb0933580c1.svg";